import classNames from 'classnames';
import Label from './text/label';

interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
	label?: string;
	containerClassName?: string;
}

const TextArea = ({
	className,
	label,
	containerClassName,
	...props
}: TextAreaProps) => (
	<div
		className={classNames(
			'flex flex-col relative group',
			containerClassName
		)}
	>
		{label && (props.disabled || props.value) && (
			<Label
				className={classNames(
					'absolute -top-2 text-xs bg-white group-focus-within:text-primary',
					{
						'left-3 px-1': !props.disabled,
					}
				)}
			>
				{label}
			</Label>
		)}
		<textarea
			className={classNames(
				'border border-gray-border rounded-md resize-none focus:border-primary outline-primary placeholder:text-gray-label px-3 py-2',
				className
			)}
			{...props}
		></textarea>
	</div>
);

export default TextArea;
